/* eslint-disable import/no-anonymous-default-export */
import { authRepository } from '../repositories'

function useSignInVerify() {
	const [_verify, { data, isLoading, isError, isSuccess }] =
		authRepository.useVerifyMutation()

	async function execute({ ...data }: { email: string }) {
		try {
			await _verify(data).unwrap()
		} catch (error) {
			console.error(error)
		}
	}

	return { execute, data, isLoading, isError, isSuccess }
}

export default {
	signInVerify: useSignInVerify,
}
